import $ from 'jquery';

export const index = ctx => {
  const modal = $('#techModal');
  const createButton = $('#createButton');
  const validationButton = modal.find('.ui.button');

  createButton.on('click', function(evt) {
    evt.preventDefault();
    modal.modal('show');
  });

  validationButton.on('click', function(evt) {
    evt.preventDefault();

    const techId = $('#techId').val();
    const newUrl = $('#techModal').attr('data-url');
    if (techId && newUrl) {
      window.location.href = newUrl.replace('-1', techId);
    }
  });
};



// WEBPACK FOOTER //
// ./src/modules/workers/index.js